import { normalize } from "./utils/path.js";
export function createExclude(excludeConfig) {
    const checks = excludeConfig.map((exclude) => typeof exclude === "string" ? (path) => path === exclude : (path) => exclude.test(path));
    return (path) => checks.some((check) => check(normalize(path)));
}
